(() => {
const chooseAddonRows = function chooseAddonRows(rows,gap) {
  let preferred=[];
  if(gap>0){
    let best=null;
    for(let mask=1;mask<(1<<rows.length);mask++){
      const selected=rows.filter((_,i)=>mask&(1<<i));
      if(selected.length>3||new Set(selected.map(r=>r.family)).size!==selected.length)continue;
      const total=selected.reduce((sum,r)=>sum+r.price,0);
      if(total<gap)continue;
      const score=total-gap+selected.length*0.001+selected.reduce((sum,r)=>sum+r.rank,0)*0.000001;
      if(!best||score<best.score)best={score,selected};
    }
    if(best)preferred=best.selected;
  }
  const result=[],families=new Set();
  for(const row of preferred.concat(rows)){
    if(families.has(row.family))continue;
    result.push(row);families.add(row.family);
    if(result.length===3)break;
  }
  return result;
}
if (!customElements.get('cozoraliving-addons')) {
  customElements.define('cozoraliving-addons', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.prices = new Map(JSON.parse(this.querySelector('[data-coz-main-prices]')?.textContent || '[]').map(v => [v.id,v.price]));
      this.cartSubtotal = 0;
      this.onChange = (event) => {
        const select = event.target.closest('[data-coz-addon-variant]');
        if (select) {
          const row = select.closest('[data-coz-addon-row]');
          const option = select.selectedOptions[0];
          row.querySelector('[data-coz-addon-price]').textContent = option.dataset.price;
          const image = row.querySelector('.coz-addons__img');
          if (image?.tagName === 'IMG' && option.dataset.image) {
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
          }
        }
        if (!event.target.closest('cozoraliving-addons')) this.rankRows();
        this.updateTotal();
      };
      this.form?.addEventListener('change', this.onChange);
      this.form?.addEventListener('input', this.onChange);
      const variantInput = this.form?.querySelector('[name="id"]');
      this.observer = new MutationObserver(() => { this.rankRows(); this.updateTotal(); });
      if (variantInput) this.observer.observe(variantInput,{attributes:true,attributeFilter:['value']});
      this.rankRows();
      this.updateTotal();
      if (this.dataset.us === 'true') {
        fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
          .then(r => r.ok ? r.json() : null)
          .then(cart => { if(cart?.currency === 'USD' && this.isConnected){ this.cartSubtotal=cart.total_price; this.rankRows(); } })
          .catch(() => {});
      }
    }
    updateTotal() {
      const output = this.querySelector('[data-coz-product-total]');
      if (!output) return;
      const id = this.form?.querySelector('[name="id"]')?.value;
      const price = this.prices.get(id) ?? Number(this.dataset.basePrice);
      const quantity = Math.max(1, Number(this.form?.querySelector('[name="quantity"]')?.value || 1));
      let total = price * quantity;
      for (const row of this.querySelectorAll('[data-coz-addon-row]')) {
        if (!row.querySelector('[data-coz-addon-toggle]')?.checked) continue;
        const option = row.querySelector('[data-coz-addon-variant]')?.selectedOptions[0];
        if (option && !option.disabled) total += Number(option.dataset.cents || 0) * Math.max(1, Number(option.dataset.quantity || 1));
      }
      output.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: this.dataset.currency || window.Shopify?.currency?.active || 'USD'
      }).format(total / 100);
    }
    rankRows() {
      const rows=Array.from(this.querySelectorAll('[data-coz-addon-row]')).map(el => {
        const option=el.querySelector('[data-coz-addon-variant]')?.selectedOptions[0];
        return {el,family:el.dataset.family,rank:Number(el.dataset.rank),price:Number(option?.dataset.cents || 0)*Number(option?.dataset.quantity || 1)};
      }).sort((a,b)=>a.rank-b.rank);
      const selected=rows.filter(row=>row.el.querySelector('[data-coz-addon-toggle]').checked);
      if(selected.length)return;
      const id=this.form?.querySelector('[name="id"]')?.value;
      const price=this.prices.get(id) ?? Number(this.dataset.basePrice);
      const quantity=Math.max(1,Number(this.form?.querySelector('[name="quantity"]')?.value || 1));
      const gap=this.dataset.us === 'true' ? Math.max(0,6900-price*quantity-this.cartSubtotal) : 0;
      const visible=chooseAddonRows(rows,gap);
      const container=this.querySelector('.coz-addons__items');
      if(!container)return;
      for(const row of rows)row.el.hidden=!visible.includes(row);
      for(const row of visible)container.appendChild(row.el);
    }
    disconnectedCallback() {
      this.form?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('input', this.onChange);
      this.observer?.disconnect();
    }
  });
}
})();
